module.exports = __webpack_public_path__ + "media/images/front/team/manolo_montero-fc9af4a17fa7a31c0cdbfa91f4c2ee00.jpg";